import React from 'react'
import { TITLE, LOGO_URL } from '../../constants'

import './logo.css'

const Logo = ({ variant = 'home', className = '' }) => {
  const classes = [
    'brand-logo',
    variant === 'header' ? 'brand-logo--header' : '',
    className
  ].filter(Boolean).join(' ')

  return (
    <div className={classes}>
      <div className="brand-logo-text">
        <span className="brand-logo-title">{TITLE}</span>
        <span className="brand-logo-tagline">Intelligent Innovation</span>
      </div>
      <img src={LOGO_URL} alt={TITLE} className="brand-logo-mark" />
    </div>
  )
}

export default Logo
